import React from 'react'
import { useTranslation } from 'react-i18next'

import { useDispatch } from '@hozana/redux/hooks'
import { TRACKING_SOURCE, UTM } from '@hozana/tracking/constants'
import { nl2br } from '@hozana/utils/functions/strings'

import { Button } from 'elements/button/Button'
import { Div, TDivProps } from 'elements/layout/Div'
import { AnimatedCheckIcon } from 'elements/motion/AnimatedCheckIcon'
import { P } from 'elements/text/P'
import { Alert } from 'elements/ui/Alert'

import { openPopin } from 'general/actions'
import { POPINS } from 'general/managers/popins/constants'

import { useIntentionJustPublished } from 'modules/intention/hooks/useIntentionJustPublished'
import { useMyIntention } from 'modules/intention/hooks/useMyIntention'
import { SHARE_OBJECTS } from 'modules/share/constants'

export const InviteToShareIntentionsMessage: TFCC<TDivProps> = ({ m, ...otherProps }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const myIntention = useMyIntention()

  const justPublished = useIntentionJustPublished()

  const openShareIntentionPopin = () =>
    dispatch(
      openPopin(POPINS.InvitePopin, {
        objectToShare: SHARE_OBJECTS.INTENTION,
        intention: myIntention,
        utmContent: UTM.CONTENT.INVITE_TO_PRAY_INTENTIONS_MESSAGE,
        trackingSource: TRACKING_SOURCE.INTENTION,
      }),
    )

  return (
    <Div h={justPublished ? 'unset' : '0px'} transition noOverflow {...otherProps}>
      <Alert p={justPublished ? '10px' : '0px'} m={m}>
        <P m="0 0 5px" align="center">
          {justPublished && <AnimatedCheckIcon size="2em" delay={1000} color="darkGreen" />}{' '}
          {nl2br(t('intention:intention.want-to-share'))}
        </P>
        <Div align="center" m="10px 0">
          <Button
            onClick={openShareIntentionPopin}
            bg="darkGreen"
            borderColor="darkGreen"
            hoverBorderColor="darkGreen"
            hoverColor="darkGreen"
            size="small"
          >
            trans:intention:share.my-intention
          </Button>
        </Div>
      </Alert>
    </Div>
  )
}
